import "core-js/modules/es.array.push.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col gap-2.5 w-full h-full"
};
const _hoisted_2 = {
  class: "flex flex-col lg:flex-row items-center justify-between gap-2"
};
const _hoisted_3 = {
  class: "flex flex-col lg:flex-row items-center gap-2 lg:gap-6 w-full"
};
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = {
  class: "text-surface-900 text-sm font-semibold font-inter"
};
import OverviewTreeTable from "@/components/overview/logged-time/OverviewTreeTable.vue";
import TimeOffTreeTable from "@/components/overview/time-off/TimeOffTreeTable.vue";
import { OVERVIEW_TABS } from "@/utils/const";
import { ref, watch } from "vue";
import { SelectButton } from "primevue";
import { useRouter } from "vue-router";
export default {
  __name: 'TimeManagementOverview',
  setup(__props) {
    const router = useRouter();
    const activeTab = ref(OVERVIEW_TABS.LOGGED_TIME.value);
    const tabs = ref([OVERVIEW_TABS.LOGGED_TIME, OVERVIEW_TABS.TIME_OFF]);

    // activeTab changes, update the query parameter
    watch(() => activeTab.value, newVal => {
      router.push({
        query: {
          tab: newVal
        }
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(SelectButton), {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        options: tabs.value,
        "option-value": "value",
        "option-label": "label",
        allowEmpty: false,
        class: "w-full"
      }, {
        option: _withCtx(slotProps => [_createElementVNode("div", _hoisted_4, [_createElementVNode("i", {
          class: _normalizeClass(slotProps.option.icon + ' text-surface-500 !text-sm !leading-4')
        }, null, 2), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$tf(slotProps.option.label)), 1)])]),
        _: 1
      }, 8, ["modelValue", "options"])])]), activeTab.value === _unref(OVERVIEW_TABS).LOGGED_TIME.value ? (_openBlock(), _createBlock(OverviewTreeTable, {
        key: 0
      })) : _createCommentVNode("", true), activeTab.value === _unref(OVERVIEW_TABS).TIME_OFF.value ? (_openBlock(), _createBlock(TimeOffTreeTable, {
        key: 1
      })) : _createCommentVNode("", true)]);
    };
  }
};